import e from"styled-components";const t=e.div`
	padding: 16px 24px;
	background-color: ${({theme:e})=>e.bg.secondary};
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 3px;
		background: linear-gradient(
			90deg,
			#003661 -14.07%,
			#003bff 28.94%,
			#00afff 72.41%,
			#00d1c3 117.74%
		);
	}
`,i=e.div`
	display: flex;
	align-items: center;
	gap: 12px;
`,o=e.div`
	width: 42px;
	height: 42px;
	background: url("https://caelor-apps.web.app/images/logo/optics.svg");
`,n=e.h1`
	margin: 0;
	font-size: 18px;
	font-weight: 500;
	font-family: "PP Formula";
	line-height: 1;
	color: ${({theme:e})=>e.text.title};
`,p=e.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;export{i as HeaderBrandContainer,o as HeaderBrandCover,n as HeaderBrandName,p as HeaderButtonsContainer,t as HeaderContainer};
